var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.questions),function(question,index){return _c('review-question',{key:index,attrs:{"hide-change-links":_vm.hideChangeLinks,"question":question,"question-id":index,"is-resident":_vm.isVoterResident}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bff3c650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Review/ReviewQuestions.vue
// module id = QBJX
// module chunks = 1